/* eslint-disable react/prefer-stateless-function */
import React, { memo } from "react";
import { DealHeroCard } from "@loanbossinc/component-library";

import { getMetricList } from "../heroCard_Util";

const GenericHeroCard = props => {
  const {
    backLabel,
    buttons,
    cancel,
    deal,
    history,
    loan,
    displayMetrics,
    hideBackButton,
    onBackButtonClick,
    rightTopButton,
    save,
    title
  } = props;

  if (!deal) {
    return null;
  }

  const buttonList = !buttons ? [] : buttons;

  if (save) {
    buttonList.push({
      label: "Save Changes",
      onClick: () => {
        save();
      }
    });
  }

  if (cancel) {
    buttonList.push({
      label: "Reset",
      onClick: () => {
        cancel();
      }
    });
  }

  const topButtons = [];

  if(hideBackButton !== true) {
    topButtons.push({
        label: backLabel,
        iconName: "arrow_forward",
        topButtonAlignment: "left",
        onClick: () => (onBackButtonClick ? onBackButtonClick() : history.goBack())
    });
  }

  if (rightTopButton) {
    topButtons.push(rightTopButton);
  }

  const metricsList = displayMetrics ? getMetricList(deal, loan) : [];
  return <DealHeroCard title={title} dealMetricList={metricsList} topButtons={topButtons} buttonList={buttonList} />;
};

export default memo(GenericHeroCard);
